import SelectDropdownInput from "../SelectDropdown/SelectDropdownInput"

const LookupInput = ({ choice_items = [], ...props }) => <SelectDropdownInput options={choice_items} {...props} />

export default LookupInput